import { useContext, useRef } from "react";
import { ACCESS_TOKEN_KEY, AuthContext } from "../contexts/auth-context";
import customAxios from "./axios";
import jwt_decode from "jwt-decode";

import {DateTime} from "luxon";
import { log } from "../logger.js";

const isAccessTokenExpired = () => {
  const accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);
  const decoded = jwt_decode(accessToken);
  return DateTime.now() >= DateTime.fromSeconds(decoded.exp);
};

const AxiosInterceptor = () => {
  const { isAuthenticated, refreshToken, logout } = useContext(AuthContext);
  const accessTokenInterceptor = useRef(null);
  const refreshTokenInterceptor = useRef(null);
  if (accessTokenInterceptor.current)
    customAxios.interceptors.request.eject(accessTokenInterceptor.current);
  accessTokenInterceptor.current = customAxios.interceptors.request.use(
    async (config) => {
      const accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);

      if (accessToken) {
        const bearer = `Bearer ${accessToken}`;
        if (config.headers) {
          config.headers.Authorization = bearer;
        } else {
          config.headers = { authorization: bearer };
        }
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
  if (refreshTokenInterceptor.current)
    customAxios.interceptors.request.eject(refreshTokenInterceptor.current);
  refreshTokenInterceptor.current = customAxios.interceptors.request.use(
    async (config) => {
      if (
        config.url !== "/auth/refresh-token" &&
        isAuthenticated &&
        isAccessTokenExpired()
      ) {
        log.debug("Refreshing token...");
        try {
          await refreshToken();
        } catch (error) {
          log.debug("Failed to refresh token...");
          if (
            error.response &&
            (error.response.status === 400 || error.response.status === 401)
          )
            await logout();
          throw error;
        }
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
};

export default AxiosInterceptor;
